import { afterNextRender, Component, effect, inject, OnDestroy, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './components/header/header';
import { Footer } from './components/footer/footer';
import { ApiService } from './services/api.service';
import { CommonModule } from '@angular/common';
import { LocalStorageService } from './services/local-storage.service';
import { SignalRService } from './services/signalr.service';
import { AnalyticsService } from './services/analytics';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,Header,Footer, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnDestroy {
  private analytics = inject(AnalyticsService);
  protected readonly title = signal('Vishwrang Olympiad');
  private signalrService = inject(SignalRService);
  catchLoaderSubRef:any;
  translateSubs:any;
  isLoaderShow =  signal<boolean>(false);  
  private translateInstance:TranslateService = inject(TranslateService);
  constructor(public apiService : ApiService, public localStorageInstance: LocalStorageService){    
    afterNextRender(() => { 
      this.catchLoaderSubRef = this.apiService.onCatchLoaderChange.subscribe((event:any)=>{      
        this.isLoaderShow.set(event);
      });
      this.translateSubs = this.translateInstance.onLangChange.subscribe((event:any) => {
        document.body.classList.remove('lang-en', 'lang-hi');
        document.body.classList.add(`lang-${event.lang}`);
      }); 
      this.analytics.init();
    }); 
    effect(() => {
      const msg = this.signalrService.newMessageReceived();
      if (msg) {
        this.triggerGlobalNotificationToast(msg);
      }
    });    
  }  
  private triggerGlobalNotificationToast(msg: any) {
    //console.log(`Global System Alert: New message from ${msg.senderName}!`);
    // Drop your standard app-wide UI toast notification library call here
  }
  ngOnDestroy(): void {
   if(this.catchLoaderSubRef) this.catchLoaderSubRef.unsubscribe();
   if(this.translateSubs) this.translateSubs.unsubscribe();
  }
}
